import React, { useState, useEffect } from 'react';

// --- CONSTANTES ---
// Estas constantes son necesarias para los menús desplegables del formulario.
const STATUS_OPTIONS = ["Enviado", "Entregado", "Anulado", "Devolución"];
const PAYMENT_METHOD_OPTIONS = ["Efectivo", "Transferencia", "POS", "Link", "Depósito"];


function PackageForm({ onSubmit, onCancel, initialData, isLoading, showAppModal, isEditingFromCourierModule }) {
    const defaultFormData = {
        orderId: '', shipDate: new Date().toISOString().split('T')[0], productValue: '', shippingCost: '', courierName: '',
        status: STATUS_OPTIONS[0], paymentMethod: PAYMENT_METHOD_OPTIONS[0], authorizationCode: '', expenses: '', deliveryDate: '', notes: ''
    };
    const [formData, setFormData] = useState(() => {
        if (initialData) {
            const formatDateForInput = (date) => date ? new Date(date).toISOString().split('T')[0] : '';
            return {
                ...defaultFormData,
                ...initialData,
                shipDate: initialData.shipDateForForm || formatDateForInput(initialData.shipDate),
                deliveryDate: initialData.deliveryDateForForm || formatDateForInput(initialData.deliveryDate),
                productValue: initialData.productValue != null ? String(initialData.productValue) : '',
                shippingCost: initialData.shippingCost != null ? String(initialData.shippingCost) : '',
                expenses: initialData.expenses != null ? String(initialData.expenses) : '',
            };
        }
        return defaultFormData;
    });

    useEffect(() => {
        if (initialData) {
            const formatDateForInput = (date) => date ? new Date(date).toISOString().split('T')[0] : '';
            setFormData({
                ...defaultFormData,
                ...initialData,
                shipDate: initialData.shipDateForForm || formatDateForInput(initialData.shipDate),
                deliveryDate: initialData.deliveryDateForForm || formatDateForInput(initialData.deliveryDate),
                productValue: initialData.productValue != null ? String(initialData.productValue) : '',
                shippingCost: initialData.shippingCost != null ? String(initialData.shippingCost) : '',
                expenses: initialData.expenses != null ? String(initialData.expenses) : '',
            });
        } else {
            setFormData(defaultFormData);
        }
    }, [initialData]);

    const handleChange = (e) => { const { name, value } = e.target; setFormData(prev => ({ ...prev, [name]: value })); };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.orderId || !formData.shipDate || !formData.courierName ) {
            if (typeof showAppModal === 'function') {
                 showAppModal("Campos Incompletos", "Por favor, complete los campos obligatorios: # Pedido, Fecha Envío, Mensajero.");
            }
            return;
        }
        onSubmit(formData);
    };

    const isEditing = !!initialData;
    const finalStatusForAutoDate = ["entregado", "anulado", "devolución"];
    const deliveryDateShouldBeAutoSet =
        isEditing &&
        !(initialData && initialData.deliveryDate) &&
        formData.status &&
        finalStatusForAutoDate.includes(formData.status.toLowerCase());

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 md:p-8 rounded-xl shadow-2xl space-y-6 mb-8 ring-1 ring-gray-200">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-3">{initialData ? 'Editar Paquete' : 'Registrar Nuevo Paquete'}</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div><label htmlFor="orderIdForm" className="block text-sm font-medium text-gray-700 mb-1"># Pedido *</label>
                <input id="orderIdForm" type="text" name="orderId" value={formData.orderId} onChange={handleChange} required
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}/>
                </div>
                <div><label htmlFor="shipDateForm" className="block text-sm font-medium text-gray-700 mb-1">Fecha Envío *</label>
                <input id="shipDateForm" type="date" name="shipDate" value={formData.shipDate} onChange={handleChange} required
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}/>
                </div>
                <div><label htmlFor="statusForm" className="block text-sm font-medium text-gray-700 mb-1">Estado *</label>
                <select id="statusForm" name="status" value={formData.status} onChange={handleChange} required
                        className="input-field bg-white">
                    {STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select></div>
            </div>
            <h3 className="text-lg font-medium text-gray-700 mt-2 pt-4 border-t">Información Financiera</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div><label htmlFor="productValueForm" className="block text-sm font-medium text-gray-700 mb-1">Valor Producto (Q)</label>
                <input id="productValueForm" type="number" step="0.01" name="productValue" value={formData.productValue} onChange={handleChange} placeholder="0.00"
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}/>
                </div>
                <div><label htmlFor="shippingCostForm" className="block text-sm font-medium text-gray-700 mb-1">Costo Envío (Q)</label>
                <input id="shippingCostForm" type="number" step="0.01" name="shippingCost" value={formData.shippingCost} onChange={handleChange} placeholder="0.00"
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}/>
                </div>
                <div><label htmlFor="expensesForm" className="block text-sm font-medium text-gray-700 mb-1">Gastos (Q)</label>
                <input id="expensesForm" type="number" step="0.01" name="expenses" value={formData.expenses} onChange={handleChange} placeholder="0.00" className="input-field"/>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Total Paquete (Calculado)</label><p className="p-3 bg-gray-100 rounded-lg text-gray-800">Q {(parseFloat(formData.productValue || 0) + parseFloat(formData.shippingCost || 0)).toFixed(2)}</p></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Total Neto (Calculado)</label><p className="p-3 bg-gray-100 rounded-lg text-gray-800">Q {((parseFloat(formData.productValue || 0) + parseFloat(formData.shippingCost || 0)) - parseFloat(formData.expenses || 0)).toFixed(2)}</p></div>
            </div>
            <h3 className="text-lg font-medium text-gray-700 mt-2 pt-4 border-t">Responsable</h3>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                <div><label htmlFor="courierNameForm" className="block text-sm font-medium text-gray-700 mb-1">Mensajero *</label>
                <input id="courierNameForm" type="text" name="courierName" value={formData.courierName} onChange={handleChange} required
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}/>
                </div>
            </div>
            <h3 className="text-lg font-medium text-gray-700 mt-2 pt-4 border-t">Pago y Entrega</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div><label htmlFor="paymentMethodForm" className="block text-sm font-medium text-gray-700 mb-1">Forma de Pago *</label>
                <select id="paymentMethodForm" name="paymentMethod" value={formData.paymentMethod} onChange={handleChange} required className="input-field bg-white">
                    {PAYMENT_METHOD_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select></div>
                <div><label htmlFor="authorizationCodeForm" className="block text-sm font-medium text-gray-700 mb-1">Autorización (si aplica)</label>
                <input id="authorizationCodeForm" type="text" name="authorizationCode" value={formData.authorizationCode} onChange={handleChange} className="input-field"/>
                </div>
                <div>
                    <label htmlFor="deliveryDateForm" className="block text-sm font-medium text-gray-700 mb-1">Fecha Entrega/Resolución</label>
                    <input
                        id="deliveryDateForm" type="date" name="deliveryDate"
                        value={formData.deliveryDate || ''}
                        onChange={handleChange}
                        disabled={isEditingFromCourierModule && isEditing}
                        className={`input-field ${(isEditingFromCourierModule && isEditing) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                    />
                     {(isEditingFromCourierModule && isEditing && !(initialData && initialData.deliveryDate) && deliveryDateShouldBeAutoSet) && (
                         <p className="text-xs text-gray-500 mt-1">Se asignará la fecha actual al guardar con este estado.</p>
                    )}
                </div>
            </div>
            <div><label htmlFor="notesForm" className="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
            <textarea id="notesForm" name="notes" value={formData.notes} onChange={handleChange} rows="3" className="input-field"></textarea></div>
            <div className="flex justify-end space-x-4 pt-4 border-t mt-6">
                <button type="button" onClick={onCancel} disabled={isLoading} className="btn-secondary">Cancelar</button>
                <button type="submit" disabled={isLoading} className="btn-primary">{isLoading ? 'Procesando...' : (initialData ? 'Actualizar' : 'Guardar')}</button>
            </div>
        </form>
    );
}

export default PackageForm;
